import React, { useCallback } from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import { usePlayerStore } from "../../store/usePlayerStore";
import { DefaultPreviewPlayButton } from "../PlayButton/DefaultPreviewPlayButton";
import { SmallPreviewPlayButton } from "../PlayButton/SmallPreviewPlayButton";

export const PreviewPlayButton = ({
  afterPlayClick
}: {
  afterPlayClick?: () => void;
}) => {
  const { getState } = usePlayerStore();
  const { smallPlayButton } = useEmbedParametersContext();

  const onKeyUp = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key.toLowerCase() === "k") {
        const { isPaused, player } = getState();
        if (isPaused) {
          player.play();
          afterPlayClick?.();
        } else {
          player.pause();
        }
      }
    },
    [afterPlayClick, getState]
  );

  return (
    <div onKeyUp={onKeyUp}>
      {smallPlayButton ? (
        <SmallPreviewPlayButton />
      ) : (
        <DefaultPreviewPlayButton />
      )}
    </div>
  );
};
